// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1JZ9p","title":"ClientCherryInfo_title__24Cvm","itemText":"ClientCherryInfo_itemText__1PhXC"};